import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackEmotionRatingListing from "../EmotionRating/FeedbackEmotionRatingListing";

import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";

export const Question7FlashCoachExperience = ({
  easeOfNavigationRating,
  updateEmotionRatingFormData,
}) => {
  return (
    <>
      <FeedbackFormLayout
        title={"Experience with FLASH Coach"}
        subtitle={
          "Tell us about your experience using the platform and what you’d improve."
        }
      >
        <FeedbackHeader
          title={"How easy was it to navigate and find what you need?"}
        />
        <FeedbackEmotionRatingListing
          inputID={"easeOfNavigationRating"}
          emotionRatingList={easeOfNavigationRating}
          updateEmotionRatingFormData={updateEmotionRatingFormData}
        />
      </FeedbackFormLayout>
    </>
  );
};
